module.exports = "mutation UpdateProductTag($tag:UpdateTagInput!){updateProductTag(tag:$tag){success}}"